var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout max-w-lg mx-auto bg-pttr-white"},[_c('HeaderComp',{attrs:{"menu":false,"bg":""}}),_c('router-view',{staticClass:"layout-main"}),_c('FooterComp',{attrs:{"bg":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }